import "../scss/style.scss";
import "./home.js";
import "./solution.js";
import "./csj.js";
import "./faq.js";
import "./download.js";
import "./movie.js";
import "./csxh.js";
import "jquery.quicksearch";
import "jquery-match-height";
import lity from "lity";

jQuery(function ($) {

	// smooth scroll
	$(function () {
		$('a[href^="#"]').click(function () {
			var headerH = 0;
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? "body" : href);
			var position = target.offset().top - headerH;
			$("html, body").animate({ scrollTop: position }, 800, "swing");
			return false;
		});
	});

	// pagetop
	$(function(){
		$(window).scroll(function () {
			if($(this).scrollTop() >= 500) {
				$('.totop').fadeIn();
				$('.js-scroll').fadeOut();
			} else {
				$('.totop').fadeOut();
				$('.js-scroll').fadeIn();
			}
			var scrollHeight = $(document).height();
			var scrollPosition = $(window).height() + $(window).scrollTop();
			var footerHeight = $(".js-footer").innerHeight();
			if ( scrollHeight - scrollPosition  <= footerHeight - 45 ) {
				$(".js-pagetop").addClass('is-stop');
			} else {
				$(".js-pagetop").removeClass('is-stop');
			}
		});
	});

	$(document).ready(function () {
		$('.navBtn').on('click', function () {
			if ($('#nav').hasClass('close')) {
				$("#nav").removeClass('close');
				$(this).removeClass('close');
			} else {
				$("#nav").addClass('close');
				$(this).addClass('close');
			}
		});
		$('.header__navList li a,.header__navList__closeBtn').on('click', function () {
			$("#nav").removeClass('close');
			$('.navBtn.close').removeClass('close');
		});
	});

	// header fixed
	$(document).ready(function () {
		if (window.matchMedia("(max-width: 767px)").matches) {
			$('.header__navList__navItem a').on('click', function () {
				$(this).toggleClass('open');
				$(this).next().slideToggle();
			});
		} else {
			$('.header__navList__navItem').on('mouseenter', function () {
				$(this).find('.header__navList__pullDown').addClass('is_open');
			}).on('mouseleave', function () {
				$(this).find('.header__navList__pullDown').removeClass('is_open');
			});
		}
	});

	// header fixed
	$(window).on("scroll", function(){
		$(".js-header").css("left", -$(window).scrollLeft());
	});
	$(function(){
		var headerH = $('.js-header').outerHeight();
		$('body').css('padding-top', headerH + 'px');
	});

	//スクロールされたらフェードイン & アップ
	$(window).scroll(function () {
		$('.fade-in,.fade-in-left,.fade-in-right,.fade-up').each(function () {
			var elemPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos - windowHeight + windowHeight / 7) {
				$(this).addClass('scrollin');
			}
			// else {
			// 	$(this).removeClass('scrollin');
			// }
		});
	});

	$(function() {
		$('.js-matchHeight').matchHeight();
	});

	$(function() {
		$('.header .icoGrass').on('mouseenter', function () {
			$('.search-modal').toggleClass('active');
			$('.search-modal').slideToggle();
		});
		$('.header .search-modal').on('mouseleave', function () {
			$('.search-modal').removeClass('active');
			$('.search-modal').slideUp();
		});
	});

	// pulldown
	$('.js-pullDown').on('click', function (event) {
		event.preventDefault();
		$(this).toggleClass('pull-on');
		$(this).prev().slideToggle(250);
		if ($(this).hasClass('pull-on')) {
			$(this).html('3件表示に戻す');
		} else {
			$(this).html('全ての記事を見る');
		}
	});

	// ポップアップ用cookie
	var date = new Date().getTime();

	$(document).ready(function(){
		$(".cl").on('click', function () {
			setCookie("hiku", "on");
			setCookie("hikudate", date);
			localStorage.setItem("temp2", "on");
			$(".hiku").remove();
		});
		$(".hiku a").on('click', function () {
			setCookie("hiku", "on");
			setCookie("hikudate", date);
			localStorage.setItem("temp2", "on");
			location.href="https://canadiansolar.zoom.us/webinar/register/4916182029516/WN_fvIC1tPfT7SibfvIj0rdmQ";
		});
	});
	var time = parseInt(date)-parseInt(getCookie("hikudate"));
	if((getCookie("hiku")=='on' || localStorage.getItem("temp2")=="on") && time<3600000){
		$(".hiku").remove();
	}

	function setCookie(name, value)
	{
		var Days = 30;
		var exp = new Date();
		exp.setTime(exp.getTime() + Days*24*60*60*1000);
		document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()+ ";path=/;samesite=Lax";
	}
	function getCookie(name)
	{
		var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
		if(arr=document.cookie.match(reg))
			return unescape(arr[2]);
		else
			return null;
	}
	function delCookie(name)
	{
		var exp = new Date();
		exp.setTime(exp.getTime() - 1);
		var cval=getCookie(name);
		if(cval!=null)
			document.cookie= name + "="+cval+";expires="+exp.toGMTString();
	}

	// ポップアップバナー対応
	var img_tag = '';
	var arr,reg = new RegExp("(^| )popup=([^;]*)(;|$)");
	if (arr = document.cookie.match(reg)) {
		// cookie が設定されている場合
	} else {
		// cookie が設定されていない場合 バナー表示
		if (window.matchMedia('(max-width:787px)').matches) {
			img_tag = "<button class='lity-close' type='button' aria-label='Close (Press escape to close)' data-lity-close=''>×</button><a class='is_no_opacity' href='https://pardot.csisolar.com/l/788683/2023-01-12/4zd6x5' target='_blank'><img src='/wp-content/themes/csisolar_kr/img/bnr/banner_SP2.png'></a>";
		} else {
			img_tag = "<button class='lity-close' type='button' aria-label='Close (Press escape to close)' data-lity-close=''>×</button><a class='is_no_opacity' href='https://pardot.csisolar.com/l/788683/2023-01-12/4zd6x5' target='_blank'><img src='/wp-content/themes/csisolar_kr/img/bnr/banner_PC2.png'></a>";
		}
		// var instance = lity(img_tag);
	}

	$(document).on('lity:close', function (event, instance) {
		var exp = new Date();
		exp.setTime(exp.getTime() + 24*60*60*1000); // 1日
		document.cookie = "popup=on;expires=" + exp.toGMTString() + ";path=/;";
	});

	$('.lity-content a').on('click', function () {
		instance.close().then(function() {
			var exp = new Date();
			exp.setTime(exp.getTime() + 24*60*60*1000); // 1日
			document.cookie = "popup=on;expires=" + exp.toGMTString() + ";path=/;";
		});
	});

});
